"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const colors_1 = __importDefault(require("./colors"));
const themes = {
    textInput: {
        colors: {
            placeholder: colors_1.default.FONT_BLACK,
            text: colors_1.default.FONT_BLACK,
            primary: colors_1.default.FONT_BLACK,
            onSurfaceVariant: colors_1.default.FONT_BLACK,
            onSurface: colors_1.default.FONT_BLACK,
            onSurfaceDisabled: colors_1.default.GRAY_3,
        },
    },
    tab: {
        colors: {
            placeholder: colors_1.default.FONT_BLACK,
            text: colors_1.default.FONT_BLACK,
            primary: colors_1.default.BLUE_2,
            onSurfaceVariant: colors_1.default.FONT_BLACK,
            onSurface: colors_1.default.FONT_BLACK,
            onSurfaceDisabled: colors_1.default.GRAY_3,
        },
    },
    datatable: {
        colors: {
            primary: colors_1.default.BLUE,
            onSurface: 'rgb(25, 28, 29)',
            elevation: {
                level0: 'transparent',
                level1: 'rgb(238, 246, 246)',
                level2: 'rgb(230, 241, 242)',
                level3: 'rgb(223, 237, 238)',
                level4: 'rgb(220, 235, 237)',
                level5: 'rgb(215, 232, 234)',
            },
            surfaceDisabled: 'rgba(25, 28, 29, 0.12)',
            onSurfaceDisabled: 'rgba(25, 28, 29, 0.38)',
            backdrop: 'rgba(41, 50, 52, 0.4)',
        },
    },
    modal: {
        colors: {
            backdrop: 'rgba(41, 50, 52, 0.4)',
        },
    },
};
exports.default = themes;
